import { useEffect, useState } from 'react';
import { toListWord, type ListWord } from './types';

/** The word lists, loaded on first use so they never weigh on the portal bundle. */
export function useWordList(): { words: ListWord[] | null; failed: boolean } {
  const [words, setWords] = useState<ListWord[] | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    import('./words')
      .then((module) => {
        if (alive) setWords(module.WORD_ROWS.map(toListWord));
      })
      .catch(() => {
        if (alive) setFailed(true);
      });
    return () => {
      alive = false;
    };
  }, []);
  return { words, failed };
}
